'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dImport$002dState from "./mealorama.-Import-State.js";
var $p;
/** @constructor */
function $c_Lmealorama_ImportState$$anon$17(\u03b4name$2, _$ordinal$2) {
  this.Zr = null;
  this.Zr = \u03b4name$2;
}
export { $c_Lmealorama_ImportState$$anon$17 as $c_Lmealorama_ImportState$$anon$17 };
$p = $c_Lmealorama_ImportState$$anon$17.prototype = new $j_mealorama$002e$002dImport$002dState.$h_Lmealorama_ImportState();
$p.constructor = $c_Lmealorama_ImportState$$anon$17;
/** @constructor */
function $h_Lmealorama_ImportState$$anon$17() {
}
export { $h_Lmealorama_ImportState$$anon$17 as $h_Lmealorama_ImportState$$anon$17 };
$h_Lmealorama_ImportState$$anon$17.prototype = $p;
$p.q = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.r = (function() {
  return this.Zr;
});
$p.m = (function() {
  return this.Zr;
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Zr);
});
var $d_Lmealorama_ImportState$$anon$17 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ImportState$$anon$17, "mealorama.ImportState$$anon$17", ({
  FT: 1,
  jD: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  n: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_ImportState$$anon$17 as $d_Lmealorama_ImportState$$anon$17 };
//# sourceMappingURL=mealorama.-Import-State$$anon$17.js.map
